<template>
    <v-container id="hitnrun-table-container">
        <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->
        <v-data-table :headers="headers" show-expand :single-expand="true" :expanded.sync="expanded" :loading="loading" :height="$vuetify.breakpoint.xs ? 425 : '50vh'"
                      :items="data"
                      item-key="hitrunID"
                      selectable-key="hitrunID"
                      :items-per-page="15"
                      :server-items-length="serverTotalCount"
                      :search="searchfield"
                      class="elevation-1 backdrop"
                      :custom-filter="customSearch"
                      @dblclick:row="(item, slot) => slot.expand(!slot.isExpanded)"
                      @update:options="optionsChanged"
                      :footer-props="{'items-per-page-options':[10, 20, 30, 50, -1], 'items-per-page-text' : 'Records per page:'}"
                      :no-data-text="`No Incidents Found`">

            <template v-slot:top>

                <v-row v-if="!hideSearch" class="mobile-row">


                    <v-col cols="12" md="10" sm="10" class="header-col">
                        <v-text-field v-model="searchfield" outlined ref="searchField" @keydown.enter="SearchIncidents" append-icon="$send" @click:append="SearchIncidents"
                                      label="Search Using Keywords" single-line hide-details
                                      class="mx-4 py-md-4 newButton">
                            <template v-slot:prepend-inner>

                                <v-tooltip bottom :disabled="$vuetify.breakpoint.xs">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon small class="pb-3 py-1 px-4" @click="openFiltersDialog"
                                               color="white" v-bind="attrs" v-on="on">
                                            <v-icon v-if="filter_text.length == 0">$textSearch</v-icon>
                                            <v-icon v-else color="secondary">$textSearch</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Apply Additional Search Filters</span>
                                </v-tooltip>

                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="2" sm="2" align-self="center" class="header-col">

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="secondary" v-bind="attrs" v-on="on"
                                       class="my-auto black--text newButton" @click="newIncident">
                                    New
                                    <v-icon right
                                            dark>
                                        $plus
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Create A New Incident</span>
                        </v-tooltip>
                    </v-col>




                </v-row>

                <div class="ma-0">
                    <div v-if="filter_text.length > 0 && !$vuetify.breakpoint.xs" class="mx-6 d-flex text--accent-1">

                        <div v-if="filter_text.length == 1" class="d-inline-flex" style="max-width: 100%; flex-wrap: wrap;">
                            <div class="text-caption mr-1">** FILTERS ACTIVE : </div>
                            <div v-for="(text,index) in filter_text" :key="index" class="mr-2 text-caption">
                                {{text.title}} <span class="filtertext">({{text.value}})</span>
                            </div>
                        </div>

                        <div v-else class="d-inline-flex" style="max-width: 100%; flex-wrap: wrap;">
                            <div class="text-caption mr-1">** FILTERS ACTIVE : </div>
                            <div v-for="(text,index) in filter_text" :key="index" class="mr-2 text-caption">
                                {{text.title}} <span class="filtertext mr-1">({{text.value}}) </span> |
                            </div>
                        </div>

                    </div>
                </div>


            </template>


            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="backdrop lighten-1">
                    <v-container class="expanded-item-container">
                        <v-row class="mx-md-6 mx-sm-2 expanded-item-row">

                            <v-col cols="4" sm="2" align-self="center">
                                <v-tooltip v-if="item.fav" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="favoriteIncident(item.hitrunID)" color="secondary" v-bind="attrs" v-on="on" :loading="favorite_loading" :disabled="favorite_loading || item.s_del == 't'">
                                            <v-icon color="black">$star</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Remove Incident From Favorites</span>
                                </v-tooltip>
                                <v-tooltip v-else bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="favoriteIncident(item.hitrunID)" color="secondary" v-bind="attrs" v-on="on" :loading="favorite_loading" :disabled="favorite_loading || item.s_del == 't'">
                                            <v-icon color="black">$starOutline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Add Incident To Favorites</span>
                                </v-tooltip>
                            </v-col>

                            <v-col cols="4" sm="2" align-self="center">

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="editIncident(item.hitrunID)" color="secondary" v-bind="attrs" v-on="on">
                                            <v-icon color="black">$pencil</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edit Incident</span>
                                </v-tooltip>


                            </v-col>


                            <v-col cols="4" sm="2" align-self="center">

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="openIncidentLogs(item.hitrunID)" color="secondary" class="black--text" v-bind="attrs" v-on="on">
                                            <v-icon color="black">$fileDocument</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edit Logs</span>
                                </v-tooltip>



                            </v-col>

                            <v-col cols="4" sm="2">

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="ViewVictimLetter(item.hitrunID)" :loading="victim_letter_loading" :disabled="victim_letter_loading || item.s_del == 't'" color="secondary" class="black--text" v-bind="attrs" v-on="on">
                                            Victim <br />Letter
                                        </v-btn>
                                    </template>
                                    <span>Print Victim Letter</span>
                                </v-tooltip>

                            </v-col>

                            <v-col cols="4" sm="2">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="ViewSuspectLetter(item.hitrunID)" :loading="suspect_letter_loading" :disabled="suspect_letter_loading || item.s_del == 't'" color="secondary" class="black--text" v-bind="attrs" v-on="on">
                                            Suspect <br /> Letter
                                        </v-btn>
                                    </template>
                                    <span>Print Suspect Letter</span>
                                </v-tooltip>
                            </v-col>

                            <v-col cols="4" sm="2" align-self="center">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="ViewEnvelope(item.hitrunID)" :loading="envelope_loading" :disabled="envelope_loading || item.s_del == 't'" color="secondary" v-bind="attrs" v-on="on">
                                            <v-icon color="black">$email</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Print Envelope</span>
                                </v-tooltip>
                            </v-col>

                            <v-col cols="4" md="2" align-self="center">
                                <v-tooltip bottom v-if="item.s_del == 'f'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="deleteIncident(item.hitrunID)" color="secondary" v-bind="attrs" v-on="on">
                                            <v-icon color="black">$del</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Delete Record</span>
                                </v-tooltip>

                                <v-tooltip bottom v-if="item.s_del == 't'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="undeleteIncident(item.hitrunID)" color="secondary" v-bind="attrs" v-on="on">
                                            <v-icon color="black">$loop</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Restore Record</span>
                                </v-tooltip>

                            </v-col>

                        </v-row>
                    </v-container>
                </td>
            </template>

            <!--Header Field clicks-->
            <template v-slot:header.case_num="{ header }">
                <button>{{ header.text}}</button>
            </template>
            <template v-slot:header.incident_date="{ header }">
                <button>{{ header.text}}</button>
            </template>

            <!--items change-->
            <template v-slot:item.priority="{ item  }">
                <v-chip v-if="item.priority == `YES`" color="#e2483d" dark small>
                    {{ item.priority }}
                </v-chip>
                <v-chip v-if="item.priority == `NO`" dark small>
                    {{ item.priority }}
                </v-chip>
                <v-chip v-if="item.priority == `MAIT`" color="#6B5B95" dark small>
                    {{ item.priority }}
                </v-chip>
            </template>

            <template v-slot:item.status="{ item  }">
                <v-chip v-if="item.status == `ASSIGNED`" color="#34568B" dark small>
                    {{ item.status }}
                </v-chip>
                <v-chip v-if="item.status == `OPEN`" color="#6B5B95" dark small>
                    {{ item.status }}
                </v-chip>
                <v-chip v-if="item.status == `CLOSED`" color="darkgreen" dark small>
                    {{ item.status }}
                </v-chip>
                <v-chip v-if="item.status == `PENDING`" color="#f79a10" dark small>
                    {{ item.status }}
                </v-chip>
                <v-chip v-if="item.status == `SUBMITTED`" color="#4c8e4e" dark small>
                    {{ item.status }}
                </v-chip>
            </template>
        </v-data-table>
    </v-container>
</template>

<style lang="scss" scoped>
    #hitnrun-table-container {
        padding: 0px;
        max-width: none !important;
    }

    .expanded-item-container {
    }

    @media only screen and (max-width: 600px) {
        .expanded-item-row {
            text-align: center;
        }

        .newButton {
            margin-left: 16px;
            width: 89%;
            margin-right: 16px;
        }

        .header-col {
            padding: 5px 0px !important;
        }

        .mobile-row {
            padding-top: 15px;
            text-align: -webkit-center;
            margin-bottom: 10px;
            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        }
    }

    .filtertext {
        color: var(--v-secondary-base);
    }
</style>

<script>
    /* eslint-disable */
    import { bus_common } from "../mixins/bus_common";
    export default {
        name: "hitnrun-table",
        mixins: [bus_common],
        props: ["data", "hideSearch", "filter_text", "serverTotalCount", "loading", "Prop_searchfield"],
        data() {
            return {
                expanded: [],
                headers: [
                    {
                        text: 'Case Number',
                        align: 'start',
                        value: 'case_num',
                    },
                    { text: 'Incident Date', value: 'incident_date' },
                    { text: 'Date Assigned', value: 'assigned_date' },
                    { text: 'Investigator', value: 'det_off_name' },
                    { text: 'Priority', value: 'priority' },
                    { text: 'Status', value: 'status' },
                    { text: 'Date Closed', value: 'closed_date' },


                    //Hidden headers still searchable

                ],
                searchfield: this.Prop_searchfield,
                victim_letter_loading: false,
                suspect_letter_loading: false,
                envelope_loading: false,
                favorite_loading: false,

            };
        },
        methods: {
            newIncident() {
                this.$emit('newIncident');
            },
            init() { },
            customSearch(value, search, item) {
                return Object.values(item).some(v => v && v.toString().toLowerCase().includes(search.toLowerCase()))
            },
            openFiltersDialog() {
                this.$emit('openFiltersDialog');
            },
            optionsChanged(event) {
                this.$emit('optionsChanged', event)
            },
            openIncidentLogs(hitrunID) {
                this.$emit('openIncidentLogs', hitrunID);
            },
            editIncident(hitrunID) {
                this.$emit('editIncident', hitrunID)
            },
            deleteIncident(hitrunID) {
                let callback = () => {
                    this.deleteIncidentCall(hitrunID);
                }
                this.swall_diag("Delete Incident?", "Are you sure you would like to delete the incident?", "question", callback, "Yes", "No", null)
            },
            undeleteIncident(hitrunID) {
                let callback = () => {
                    this.undeleteIncidentCall(hitrunID);
                }
                this.swall_diag("Restore Incident?", "Are you sure you would like to restore the incident?", "question", callback, "Yes", "No", null)
            },
            ClearSearch() {
                this.searchfield = ""
            },
            async deleteIncidentCall(hitrunID) {

                let form = { hitrunID: hitrunID }
                await this.$axios.post('api/hitnrun/deleteIncident', form)
                    .then(response => {
                        this.$emit('refreshData');
                        this.swall_it("Incident Deleted!", "The incident was successfully deleted.", "success", null, null);

                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                        }
                    });

            },
            async undeleteIncidentCall(hitrunID) {

                let form = { hitrunID: hitrunID }
                await this.$axios.post('api/hitnrun/undeleteIncident', form)
                    .then(response => {
                        this.$emit('refreshData');
                        this.swall_it("Incident Restored!", "The incident was successfully restored.", "success", null, null);

                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                        }
                    });

            },
            SearchIncidents() {
                this.$emit('SearchIncidents')
            },
            focusSearch() {
                if (!this.hideSearch) {
                    this.$refs["searchField"].focus();
                }
            },
            focusFilters() {
                if (!this.hideSearch) {
                    this.openFiltersDialog();
                }
            },
            async favoriteIncident(hitrunID) {
                this.favorite_loading = true;
                let form = { hitrunID: hitrunID, user_email: this.$store.state.user.email }
                await this.$axios.post('api/favorite/FavoriteHitnrun', form)
                    .then(response => {
                        this.$emit('refreshData');
                        this.swall_it("Incident Updated!", response.data.msg, "success", null, null);
                        this.favorite_loading = false;

                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                            this.favorite_loading = false;
                        }
                    });
            },
            async ViewVictimLetter(hitrunID) {
                this.victim_letter_loading = true;
                let form = { hitrunID: hitrunID, user_email: this.$store.state.user.email }
                await this.$axios.post('api/printables/victim_letter', form)
                    .then(response => {
                        if (this.payloadHasEmptyData(response.data)) {
                            let callback = () => {
                                this.$emit('printVictimLetter', response.data);
                            }
                            this.swall_diag("Continue Printing?", "This victim letter has one or more empty fields, are you sure you would like to print it?", "question", callback, "Yes", "No", null)
                            this.$nextTick(() => {
                                setTimeout(() => {
                                    this.victim_letter_loading = false;
                                }, 1500)
                            });
                        }
                        else {
                            this.$emit('printVictimLetter', response.data);
                            this.$nextTick(() => {
                                setTimeout(() => {
                                    this.victim_letter_loading = false;
                                }, 1500)
                            });
                        }
                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                            this.victim_letter_loading = false;
                        }
                    });
            },

            async ViewSuspectLetter(hitrunID) {
                this.suspect_letter_loading = true;
                let form = { hitrunID: hitrunID, user_email: this.$store.state.user.email }
                await this.$axios.post('api/printables/suspect_letter', form)
                    .then(response => {
                        if (this.payloadHasEmptyData(response.data)) {
                            let callback = () => {
                                this.$emit('printSuspectLetter', response.data);
                            }
                            this.swall_diag("Continue Printing?", "This suspect letter has one or more empty fields, are you sure you would like to print it?", "question", callback, "Yes", "No", null)
                            this.$nextTick(() => {
                                setTimeout(() => {
                                    this.suspect_letter_loading = false;
                                }, 1500)

                            });
                        }
                        else {
                            this.$emit('printSuspectLetter', response.data);
                            this.$nextTick(() => {
                                setTimeout(() => {
                                    this.suspect_letter_loading = false;
                                }, 1500)

                            });
                        }

                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                            this.suspect_letter_loading = false;
                        }
                    });
            },

            async ViewEnvelope(hitrunID) {
                this.envelope_loading = true;
                let form = { hitrunID: hitrunID, user_email: this.$store.state.user.email }
                await this.$axios.post('api/printables/envelope', form)
                    .then(response => {
                        if (this.payloadHasEmptyData(response.data)) {
                            let callback = () => {
                                this.$emit('printEnvelope', response.data);
                            }
                            this.swall_diag("Continue Printing?", "This envelope has one or more empty fields, are you sure you would like to print it?", "question", callback, "Yes", "No", null)
                            this.$nextTick(() => {
                                setTimeout(() => {
                                    this.envelope_loading = false;
                                }, 1500)

                            });
                        }
                        else {
                            this.$emit('printEnvelope', response.data);
                            this.$nextTick(() => {
                                setTimeout(() => {
                                    this.envelope_loading = false;
                                }, 1500)

                            });
                        }

                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                            this.envelope_loading = false;
                        }
                    });
            },

            payloadHasEmptyData(data) {
                for (let field in data) {
                    if (data[field] == "") {
                        return true;
                    }
                }
                return false;
            }
        },

        watch: {
            searchfield() {
                this.$emit("searchFieldUpdated", this.searchfield)
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            });
        },
    };
</script>
